"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var luxon_1 = require("luxon");
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var map_1 = __importDefault(require("lodash/map"));
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var functions_1 = require("../functions");
var data_1 = require("./data");
var contrato_1 = require("./data/contrato");
var Energia = /** @class */ (function () {
    function Energia() {
    }
    /**
     * Verifica se o contrato possui reajuste a inflação
     *
     * @param dataBase Data base da contratação de energia
     * @param periodos Períodos de fornecimento de energia
     *
     * @returns boolean
     */
    Energia.hasReajusteInflacao = function (dataBase, periodos) {
        if (periodos.length > 1) {
            return true;
        }
        var dataInicio = periodos[0].dataInicio;
        return luxon_1.DateTime.fromISO(dataInicio).year !== luxon_1.DateTime.fromISO(dataBase).year;
    };
    /**
     * Obtém a data de reajuste do contrato
     *
     * @param dataBase Data base da contratação de energia
     * @param precosPeriodo Lista de preços por período
     * @param format Texto contento padrão de formatação da data (Padrão Luxon)
     *
     * @returns DateTime | string
     *
     * @throws Irá retornar erro caso não haja reajuste
     */
    Energia.getDataReajuste = function (dataBase, precosPeriodo, format) {
        if (!Energia.hasReajusteInflacao(dataBase, precosPeriodo)) {
            throw new Error('Não possui reajuste');
        }
        var periodList = map_1.default(sortBy_1.default(precosPeriodo, ['dataInicio']), 'dataInicio');
        var firstPeriodInNextYear = periodList[0];
        for (var i = 0; i < periodList.length; i += 1) {
            if (luxon_1.DateTime.fromISO(periodList[i]).year > luxon_1.DateTime.fromISO(dataBase).year) {
                firstPeriodInNextYear = periodList[i];
                break;
            }
        }
        if (format) {
            return luxon_1.DateTime.fromISO(firstPeriodInNextYear).toFormat(format);
        }
        return luxon_1.DateTime.fromISO(firstPeriodInNextYear).endOf('month');
    };
    /**
     * Obtém a data limite para uma cotação indicativa
     *
     * @param year Ano da contratação desejada
     * @param month Mes da contratação desejada
     *
     * @returns DateTime
     */
    Energia.dataLimiteCotacaoIndicativa = function (year, month) {
        return functions_1.Calendar.fromBrasiliaTimeToUTC(functions_1.Calendar.diaUtil(year, month, 4).set({
            hour: 19,
            minute: 59,
            second: 59,
        }));
    };
    /**
     * Informando a data(em UTC) de criação irá retornar um prazo(em UTC) de 15 dias para assinatura do contrato
     *
     * @param dataCriacao Data de criação do contrato em UTC
     *
     * @returns DateTime
     */
    Energia.getContratoValidade = function (dataCriacao) {
        return dataCriacao.plus({ days: contrato_1.diasCorridosParaAssinatura });
    };
    /**
     * Obtém a data de validade dentro do horário do mercado
     *
     * Se o horário de criação da validade for próximo ao horário
     * de fechamento do mercado, é adicionado mais 15min subtraído
     * da diferença entre o fechamento do mercado e a data de criação
     *
     * @param created data de criação em UTC
     * @param expireOn data de validade em UTC
     */
    Energia.fitValidadeOnMarket = function (created, expireOn) {
        var timeAddition = 15 * 60; // 15 minutes
        var dataCriacaoBrasiliaTime = functions_1.Calendar.fromUTCToBrasiliaTime(created);
        var validade = functions_1.Calendar.fromUTCToBrasiliaTime(expireOn);
        var endMarket = validade.set({ hour: 17 }).endOf('hour');
        if (validade.hour >= 18) {
            validade = endMarket;
        }
        var durationToEndMarket = endMarket.diff(dataCriacaoBrasiliaTime, 'second').seconds;
        var durationAddition = timeAddition - durationToEndMarket;
        if (durationToEndMarket >= 1 && durationToEndMarket < timeAddition) {
            validade = validade.plus({ seconds: durationAddition });
        }
        return functions_1.Calendar.fromBrasiliaTimeToUTC(validade);
    };
    /**
     * Informando a data de criação(em UTC) da proposta e o intervalo(em UTC) entre início e fim da
     * do suprimento retornaremos uma data(em UTC) que será a validade da proposta
     *
     * @param periodoSuprimento Período em UTC
     * @param dataCriacao Data de criação em UTC
     *
     * @returns DateTime em UTC
     *
     * @throws Irá retornar um erro caso não seja possível calcular a validade da proposta
     */
    Energia.getPropostaValidade = function (periodoSuprimento, dataCriacao, isCurtoPrazo) {
        var dataCriacaoBrasiliaTime = functions_1.Calendar.fromUTCToBrasiliaTime(dataCriacao);
        /**
         * Verifica se a criação é no periodo de final de semana
         */
        var isSaturday = dataCriacaoBrasiliaTime.weekday === 6;
        var isSunday = dataCriacaoBrasiliaTime.weekday === 7;
        if (isSaturday) {
            return functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime
                .plus({ day: 2 })
                .set({ hour: 8 })
                .endOf('hour'));
        }
        if (isSunday) {
            return functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime
                .plus({ day: 1 })
                .set({ hour: 8 })
                .endOf('hour'));
        }
        /**
         * Verifica se a criação está dentro do período de Off-Market,
         * caso esteja, é retornado a data de 9AM do dia seguinte ou mesmo dia
         */
        var beforeMarketStart = functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.set({ hour: 18 }).startOf('hour'));
        var beforeMarketEnd = functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.endOf('day'));
        if (luxon_1.Interval.fromDateTimes(beforeMarketStart, beforeMarketEnd).contains(dataCriacao)) {
            return functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime
                .plus({ day: 1 })
                .set({ hour: 8 })
                .endOf('hour'));
        }
        var afterMakertStart = functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.startOf('day'));
        var afterMarketEnd = functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.set({ hour: 9 }).startOf('hour'));
        if (luxon_1.Interval.fromDateTimes(afterMakertStart, afterMarketEnd).contains(dataCriacao)) {
            return functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.set({ hour: 8 }).endOf('hour'));
        }
        /**
         * Retorna data de validade com base do período
         */
        if (isCurtoPrazo) {
            return this.fitValidadeOnMarket(dataCriacao, dataCriacao.plus({
                minute: 15,
            }));
        }
        if (Math.trunc(periodoSuprimento.length('month')) < 3) {
            return this.fitValidadeOnMarket(dataCriacao, dataCriacao.plus({
                hour: 1,
            }));
        }
        if (Math.trunc(periodoSuprimento.length('month')) < 12) {
            return this.fitValidadeOnMarket(dataCriacao, functions_1.Calendar.fromBrasiliaTimeToUTC(functions_1.Calendar.fromUTCToBrasiliaTime(dataCriacao)
                .set({ hour: 17 })
                .endOf('hour')));
        }
        if (Math.trunc(periodoSuprimento.length('month')) >= 12) {
            return this.fitValidadeOnMarket(dataCriacao, dataCriacao.plus({
                day: 1,
            }));
        }
        throw new Error('Não foi possível calcular a validade da proposta');
    };
    /**
     * Informando a data de criação(em UTC) da proposta e o intervalo(em UTC) entre início e fim da
     * do suprimento retornaremos uma data(em UTC) que será a validade da proposta extendida, para
     * às 18hrs do dia seguinte, seguindo as regras de abertura do mercado e dias uteis.
     *
     * @param periodoSuprimento Período em UTC
     * @param dataCriacao Data de criação em UTC
     *
     * @returns DateTime em UTC
     *
     * @throws Irá retornar um erro caso não seja possível calcular a validade da proposta
     */
    Energia.getPropostaValidadeExtendida = function (periodoSuprimento, dataCriacao, isCurtoPrazo) {
        var dataCriacaoBrasiliaTime = functions_1.Calendar.fromUTCToBrasiliaTime(dataCriacao);
        var isDiaUtil = functions_1.Calendar.isDiaUtil(dataCriacaoBrasiliaTime);
        var beforeMarketStart = functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.set({ hour: 18 }).startOf('hour'));
        var beforeMarketEnd = functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.endOf('day'));
        var isBeforeMarket = luxon_1.Interval.fromDateTimes(beforeMarketStart, beforeMarketEnd).contains(dataCriacao);
        /**
         * Verifica se a criação está dentro do período de Off-Market (18:00h às 23:59h) ou em dias não-úteis,
         * caso esteja, é retornado a data de 9AM do dia util seguinte
         */
        if (!isDiaUtil || isBeforeMarket) {
            return functions_1.Calendar.fromBrasiliaTimeToUTC(functions_1.Calendar.getNextDiaUtil(dataCriacaoBrasiliaTime)
                .set({ hour: 8 })
                .endOf('hour'));
        }
        var afterMakertStart = functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.startOf('day'));
        var afterMarketEnd = functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.set({ hour: 9 }).startOf('hour'));
        var isAfterMarket = luxon_1.Interval.fromDateTimes(afterMakertStart, afterMarketEnd).contains(dataCriacao);
        /** Verifica se a criação está dentro do período de Off-Market (00:00h às 08:59h)
         * caso esteja, é retornado a data de 9AM do dia atual
         */
        if (isAfterMarket) {
            return functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.set({ hour: 8 }).endOf('hour'));
        }
        /* Verifica se a proposta é de Curto Prazo, neste caso o prazo de validade é de 15 minutos */
        if (isCurtoPrazo) {
            return this.fitValidadeOnMarket(dataCriacao, dataCriacao.plus({
                minute: 15,
            }));
        }
        var isFriday = dataCriacaoBrasiliaTime.weekday === 5;
        // Caso a criação seja feita na sexta-feira, retorna a data de 18hrs do dia atual
        if (isFriday) {
            return this.fitValidadeOnMarket(dataCriacao, functions_1.Calendar.fromBrasiliaTimeToUTC(dataCriacaoBrasiliaTime.set({ hour: 17 }).endOf('hour')));
        }
        // Caso a criação seja feita em dias úteis da semana (exceto sexta-feira) e em horario comercial,
        // retorna a data de 18hrs do dia util seguinte
        return functions_1.Calendar.fromBrasiliaTimeToUTC(functions_1.Calendar.getNextDiaUtil(dataCriacaoBrasiliaTime)
            .set({ hour: 17 })
            .endOf('hour'));
    };
    /**
     *
     * @param precosPorPeriodo
     *
     * @returns Money
     */
    Energia.mediaPonderadaPrecoPorHora = function (precosPorPeriodo) {
        var somatorioPrecoPonderado = new bignumber_js_1.default(0);
        var totalHoras = 0;
        for (var _i = 0, precosPorPeriodo_1 = precosPorPeriodo; _i < precosPorPeriodo_1.length; _i++) {
            var _a = precosPorPeriodo_1[_i], precoMwh = _a.precoMwh, periodo = _a.periodo;
            var horasPeriodo = functions_1.Calendar.hoursInInterval(periodo);
            var valorTotalPeriodo = new bignumber_js_1.default(precoMwh).times(horasPeriodo);
            somatorioPrecoPonderado = somatorioPrecoPonderado.plus(valorTotalPeriodo);
            totalHoras += horasPeriodo;
        }
        var precoFinal = somatorioPrecoPonderado.div(totalHoras);
        return new data_1.Money(precoFinal);
    };
    return Energia;
}());
exports.default = Energia;
